import { FuseAnimate, FusePageSimple } from "@fuse";
import { Fab, IconButton, withStyles } from "@material-ui/core";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdAdd, MdMenu } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaPessoaFormularioDialog from "./EmpresaPessoaFormularioDialog";
import EmpresaPessoaFormularioList from "./EmpresaPessoaFormularioList";
import EmpresaPessoaFormularioSidebar from "./EmpresaPessoaFormularioSidebar";
import * as Actions from "./Store/Actions/EmpresaPessoaFormularioActions";
import reducer from "./Store/Reducers/EmpresaPessoaFormularioReducer";

const styles = theme => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class EmpresaPessoaFormularioApp extends XAPPComponent {

    state = {
        selected: null,
        filters: null,
    };

    componentDidMount() {
        const { getTemplateIndex, clearFormulario, xappRouteParams, idparent, list } = this.props;
        getTemplateIndex(xappRouteParams);
        clearFormulario();
        list("SELECIONAR", xappRouteParams, idparent);
    }

    changeSelected = (_ASelected) => {
        this.setState({ selected: _ASelected });
    };

    render() {
        const { classes, openNewDialog, xappRouteParams, idparent, theme } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageSimple
                        classes={{
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "hidden"
                        }}
                        leftSidebarContent={
                            <EmpresaPessoaFormularioSidebar
                                xappRouteParams={xappRouteParams}
                                formularios={this.props.EmpresaPessoaFormulario.formularios}
                                idparent={idparent}
                                selected={form.selected}
                                changeSelected={this.changeSelected}
                                changeFilters={this.changeFilters}
                            />
                        }
                        content={
                            <React.Fragment>
                                <IconButton
                                    onClick={() => this.pageLayout.toggleLeftSidebar()}
                                    aria-label="open left sidebar"
                                >
                                    <MdMenu className={theme.palette.type === "dark" ? "text-white" : "text-black"} />
                                </IconButton>
                                <EmpresaPessoaFormularioList
                                    xappRouteParams={xappRouteParams}
                                    idparent={idparent}
                                    changeSelected={this.changeSelected}
                                    selected={form.selected}
                                />
                            </React.Fragment>
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {form.selected !== null &&
                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <Fab
                                id={"fab-add-pessoaformulario"}
                                color="primary"
                                aria-label="add"
                                className={classes.addButton}
                                onClick={() => openNewDialog(xappRouteParams)}
                            >
                                <MdAdd className="text-24 text-white" />
                            </Fab>
                        </FuseAnimate>
                    }
                    {/*  <EmpresaPessoaFormularioDialogAtendimento
                             xappRouteParams={xappRouteParams}
                             idparent={this.props.idparent}
                             formularios={this.props.EmpresaPessoaFormulario.formularios}
                             selected={form.selected}
                         /> */}
                    <EmpresaPessoaFormularioDialog
                        xappRouteParams={xappRouteParams}
                        idparent={this.props.idparent}
                        formularios={this.props.EmpresaPessoaFormulario.formularios}
                        selected={form.selected}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        clearFormulario: Actions.clearFormulario,
        openNewDialog: Actions.openNewDialog,
        getTemplateIndex: Actions.getTemplateIndex
    }, dispatch);
}

function mapStateToProps({ PessoaFormulario, fuse }) {
    return {
        EmpresaPessoaFormulario: PessoaFormulario,
        theme: fuse.settings.mainTheme,
    };
}

export default withReducer("PessoaFormulario", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaFormularioApp))));
